DialogController = App.loadClass 'core::Angular/DialogController'

class exports.EditRolesController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @service, roles) ->
        super(@scope, @transitions, @modalInstance)

        @scope.changeIsAdvisor = @changeIsAdvisor
        @scope.changeIsPendingAdvisor = @changeIsPendingAdvisor
        @scope.changeMakeCorp = @changeMakeCorp
        @scope.checkViewAll = @checkViewAll

        if roles.data.status.type is 'success'
            @scope.user = roles.data.data.user
            @scope.companies_users = roles.data.data.companies_users
        else
            @scope.no_user_message = contact.data.status.msg

    changeIsAdvisor: (cu) =>
        if cu.is_advisor is true
            cu.is_pending_advisor = false
            cu.make_corp = false

        @checkViewAll(cu)

    changeIsPendingAdvisor: (cu) =>
        if cu.is_pending_advisor is true
            cu.is_advisor = false
            cu.make_corp = false

        @checkViewAll(cu)

    changeMakeCorp: (cu) =>
        if cu.make_corp is true
            cu.is_advisor = false
            cu.is_pending_advisor = false
            cu.is_view_all = true

        @checkViewAll(cu)

    checkViewAll: (cu) =>
        # Disable box if is corporate account
        return false if cu.make_corp

        # Disable box if isn't advisor or pending
        if cu.is_advisor is false and cu.is_pending_advisor is false
            cu.is_view_all = false
            return false

        # Enable box
        return true

    save: () =>
        @setAlert({ type: 'success', msg: 'Saving...' })
        @service.updateRoles(@scope.user, @scope.companies_users)
            .then () =>
                @modalInstance.close()
